var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"sidebar-link sidebar-link-without-dropdown d-flex align-items-center position-relative",class:{
    'is-inactive':!!_vm.isInactive,
    'is-active': _vm.active,
    'navbar-expanded': _vm.navbar_expanded,
  },attrs:{"to":_vm.to}},[_c('span',{staticClass:"sidebar-link__icon"},[(_vm.img)?_vm._t("img"):_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_vm._t("icon")],2)],2),_vm._v(" "),_c('span',{staticClass:"sidebar-link__text show-expanded pl-1"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }